import {lazy} from 'react'

export const RouterSetupLazy = lazy(() => import('./RouterSetup'))
